import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
import { Chip } from '@material-ui/core';
import {
    Check as FilterAppliedIcon,
    ChevronDown as ArrowDown
} from 'lucide-react';
import React from 'react';

export const SelectorChip = ({
  isApplied,
  label,
  appliedLabel,
  onDelete,
  noArrow = false
}: {
  isApplied: boolean;
  label: React.ReactNode;
  appliedLabel: string;
  onDelete?: () => void;
  noArrow?: boolean;
}) => {
  const theme = useTheme();
  return (
    <Chip
      color={isApplied ? 'primary' : 'default'}
      classes={{
        label: css({
          display: 'inline-flex',
          alignItems: 'center'
        }),
        colorPrimary: !isApplied
          ? undefined
          : css({
              backgroundColor: theme.palette.common.black,
              color: theme.palette.common.white
            })
      }}
      onDelete={isApplied && onDelete ? onDelete : undefined}
      label={
        isApplied ? (
          <>
            <FilterAppliedIcon
              size={18}
              className={css({ marginRight: theme.spacing(1) })}
            />{' '}
            {appliedLabel}
          </>
        ) : (
          <>
            {label}
            {!noArrow && ' '}
            {!noArrow && (
              <ArrowDown
                size={18}
                className={css({ marginLeft: theme.spacing(1) })}
              />
            )}
          </>
        )
      }
    />
  );
};
